<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>老师管理</Breadcrumb-item>
        <Breadcrumb-item>开课Checklist管理</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <div class="toolbar">
      <div class="publish-info">
        <span v-if="latestVersionId">最近发布：版本 {{ latestVersionId }} · {{ latestPublishTime || '—' }}</span>
        <span v-else class="publish-empty">最近发布：暂未发布</span>
      </div>
      <div class="toolbar-actions">
        <Button type="primary" icon="plus" @click="openStageModal()">新增分类</Button>
        <Button type="primary" :loading="publishLoading" @click="publish">发布</Button>
      </div>
    </div>

    <div v-if="loading" style="text-align: center; padding: 30px 0">
      <Spin size="large"></Spin>
    </div>
    <div v-else>
      <div v-for="stage in stages" :key="stage.id" class="stage-block">
        <div class="stage-head">
          <span class="stage-name" :class="{'is-offline': !isEnabled(stage.enabled)}">{{ stage.name }}</span>
          <span class="stage-sort">排序：{{ stage.sort }}</span>
          <Tag v-if="!isEnabled(stage.enabled)" color="default">已下线</Tag>
          <div class="stage-actions">
            <Button size="small" @click="openItemModal(null, stage)">新增选项</Button>
            <Button size="small" @click="openStageModal(stage)">编辑</Button>
            <Button
              size="small"
              :type="isEnabled(stage.enabled) ? 'warning' : 'success'"
              @click="toggleStage(stage)">{{ isEnabled(stage.enabled) ? '下线' : '上线' }}</Button>
          </div>
        </div>
        <Table :columns="itemColumns" :data="stage.items || []" border stripe size="small"></Table>
      </div>
      <div v-if="!stages.length" class="empty-tip">暂未配置分类，请先新增分类</div>
    </div>

    <Modal v-model="showStageModal" :title="stageForm.id ? '编辑分类' : '新增分类'" width="480">
      <Form :label-width="90">
        <Form-item label="名称" required>
          <Input v-model="stageForm.name" placeholder="请输入分类名称" :maxlength="50"></Input>
        </Form-item>
        <Form-item label="排序">
          <InputNumber v-model="stageForm.sort" :min="0" placeholder="留空放到最后"></InputNumber>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showStageModal = false">取消</Button>
        <Button type="primary" :loading="saveLoading" @click="saveStage">保存</Button>
      </div>
    </Modal>

    <Modal v-model="showItemModal" :title="itemForm.id ? '编辑选项' : '新增选项'" width="560">
      <Form :label-width="90">
        <Form-item label="所属分类" required>
          <Select v-model="itemForm.stage" placeholder="请选择分类" style="width: 100%">
            <Option v-for="stage in stages" :value="stage.id" :key="stage.id">{{ stage.name }}</Option>
          </Select>
        </Form-item>
        <Form-item label="标题" required>
          <Input v-model="itemForm.title" placeholder="请输入标题" :maxlength="200"></Input>
        </Form-item>
        <Form-item label="说明">
          <Input v-model="itemForm.guideText" type="textarea" :rows="3" placeholder="请输入说明"></Input>
        </Form-item>
        <Form-item label="提示">
          <Input v-model="itemForm.hint" placeholder="请输入提示"></Input>
        </Form-item>
        <Form-item label="类型" required>
          <Select v-model="itemForm.itemType" placeholder="请选择类型" style="width: 100%">
            <Option :value="1">勾选</Option>
            <Option :value="2">必须填文字</Option>
            <Option :value="3">必须传图</Option>
          </Select>
        </Form-item>
        <Form-item label="排序">
          <InputNumber v-model="itemForm.sort" :min="0" placeholder="留空放到最后"></InputNumber>
        </Form-item>
      </Form>
      <div slot="footer">
        <Button type="text" @click="showItemModal = false">取消</Button>
        <Button type="primary" :loading="saveLoading" @click="saveItem">保存</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'TchOnboardingManage',
  data () {
    return {
      loading: false,
      saveLoading: false,
      publishLoading: false,
      showStageModal: false,
      showItemModal: false,
      stages: [],
      latestVersionId: null,
      latestPublishTime: '',
      stageForm: this.emptyStageForm(),
      itemForm: this.emptyItemForm(),
      itemColumns: [
        {
          title: '标题',
          key: 'title',
          minWidth: 200,
          render: (h, params) => {
            return h('span', {class: {'is-offline': !this.isEnabled(params.row.enabled)}}, params.row.title)
          }
        },
        {
          title: '说明',
          key: 'guideText',
          minWidth: 200,
          render: (h, params) => {
            return h('span', params.row.guideText || '-')
          }
        },
        {
          title: '提示',
          key: 'hint',
          minWidth: 140,
          render: (h, params) => {
            return h('span', params.row.hint || '-')
          }
        },
        {
          title: '类型',
          width: 110,
          align: 'center',
          render: (h, params) => {
            return h('span', this.itemTypeText(params.row.itemType))
          }
        },
        {
          title: '排序',
          width: 80,
          align: 'center',
          key: 'sort'
        },
        {
          title: '状态',
          width: 90,
          align: 'center',
          render: (h, params) => {
            if (this.isEnabled(params.row.enabled)) {
              return h('Tag', {props: {color: 'green'}}, '已上线')
            }
            return h('Tag', {props: {color: 'default'}}, '已下线')
          }
        },
        {
          title: '操作',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let btns = []
            btns.push(h('Button', {
              props: {type: 'primary', size: 'small'},
              style: {marginRight: '6px'},
              on: {click: () => this.openItemModal(row)}
            }, '编辑'))
            btns.push(h('Button', {
              props: {type: this.isEnabled(row.enabled) ? 'warning' : 'success', size: 'small'},
              on: {click: () => this.toggleItem(row)}
            }, this.isEnabled(row.enabled) ? '下线' : '上线'))
            return h('div', btns)
          }
        }
      ]
    }
  },
  mounted () {
    this.loadTemplate()
  },
  methods: {
    emptyStageForm () {
      return {
        id: null,
        name: '',
        sort: null
      }
    },
    emptyItemForm () {
      return {
        id: null,
        stage: null,
        title: '',
        guideText: '',
        hint: '',
        itemType: 1,
        sort: null
      }
    },
    isEnabled (enabled) {
      return enabled === 1 || enabled === true
    },
    itemTypeText (itemType) {
      if (itemType === 2) return '必须填文字'
      if (itemType === 3) return '必须传图'
      return '勾选'
    },
    loadTemplate () {
      let self = this
      self.loading = true
      self.$http.get('/tchOnboarding/template').then(function (res) {
        let data = (res && res.data) || {}
        self.stages = data.stages || []
        self.latestVersionId = data.latestVersionId || null
        self.latestPublishTime = data.latestPublishTime || ''
      }).catch(function () {
        self.stages = []
        self.latestVersionId = null
        self.latestPublishTime = ''
      }).then(function () {
        self.loading = false
      })
    },
    openStageModal (stage) {
      if (stage) {
        this.stageForm = {
          id: stage.id,
          name: stage.name,
          sort: stage.sort
        }
      } else {
        this.stageForm = this.emptyStageForm()
      }
      this.showStageModal = true
    },
    saveStage () {
      let self = this
      if (!self.stageForm.name) {
        self.$Message.warning('请输入分类名称')
        return
      }
      self.saveLoading = true
      self.$http.post('/tchOnboarding/stage/save', {
        id: self.stageForm.id,
        name: self.stageForm.name,
        sort: self.stageForm.sort
      }).then(function (res) {
        self.saveLoading = false
        if (res && res.status === 'ok') {
          self.showStageModal = false
          self.$Message.success('保存成功')
          self.loadTemplate()
        }
      }).catch(function () {
        self.saveLoading = false
      })
    },
    toggleStage (stage) {
      let self = this
      let enabled = self.isEnabled(stage.enabled) ? 0 : 1
      self.$http.post('/tchOnboarding/stage/enabled', {id: stage.id, enabled: enabled}).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success(enabled === 1 ? '已上线' : '已下线')
          self.loadTemplate()
        }
      })
    },
    openItemModal (item, stage) {
      if (item) {
        this.itemForm = {
          id: item.id,
          stage: item.stage,
          title: item.title,
          guideText: item.guideText,
          hint: item.hint,
          itemType: item.itemType,
          sort: item.sort
        }
      } else {
        this.itemForm = this.emptyItemForm()
        if (stage) {
          this.itemForm.stage = stage.id
        }
      }
      this.showItemModal = true
    },
    saveItem () {
      let self = this
      if (!self.itemForm.stage) {
        self.$Message.warning('请选择所属分类')
        return
      }
      if (!self.itemForm.title) {
        self.$Message.warning('请输入标题')
        return
      }
      if ([1, 2, 3].indexOf(self.itemForm.itemType) < 0) {
        self.$Message.warning('请选择类型')
        return
      }
      self.saveLoading = true
      self.$http.post('/tchOnboarding/item/save', {
        id: self.itemForm.id,
        stage: self.itemForm.stage,
        title: self.itemForm.title,
        guideText: self.itemForm.guideText,
        hint: self.itemForm.hint,
        itemType: self.itemForm.itemType,
        sort: self.itemForm.sort
      }).then(function (res) {
        self.saveLoading = false
        if (res && res.status === 'ok') {
          self.showItemModal = false
          self.$Message.success('保存成功')
          self.loadTemplate()
        }
      }).catch(function () {
        self.saveLoading = false
      })
    },
    toggleItem (item) {
      let self = this
      let enabled = self.isEnabled(item.enabled) ? 0 : 1
      self.$http.post('/tchOnboarding/item/enabled', {id: item.id, enabled: enabled}).then(function (res) {
        if (res && res.status === 'ok') {
          self.$Message.success(enabled === 1 ? '已上线' : '已下线')
          self.loadTemplate()
        }
      })
    },
    publish () {
      let self = this
      self.$Modal.confirm({
        title: '发布确认',
        content: '发布后会把当前上线的分类和选项生成一个新版本，确定发布吗？',
        onOk: function () {
          self.publishLoading = true
          self.$http.post('/tchOnboarding/publish').then(function (res) {
            self.publishLoading = false
            if (res && res.status === 'ok') {
              self.$Message.success('发布成功')
              self.loadTemplate()
            }
          }).catch(function () {
            self.publishLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
.list {
  padding: 20px;
}

.breadcrumb {
  margin-bottom: 20px;
}

.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 16px 20px;
  margin-bottom: 16px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.publish-info {
  color: #515a6e;
}

.publish-empty {
  color: #808695;
}

.toolbar-actions Button {
  margin-left: 8px;
}

.stage-block {
  background: white;
  padding: 16px 20px;
  margin-bottom: 16px;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.stage-head {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.stage-name {
  font-size: 15px;
  font-weight: bold;
  margin-right: 12px;
}

.stage-sort {
  color: #808695;
  margin-right: 12px;
}

.stage-actions {
  margin-left: auto;
}

.stage-actions Button {
  margin-left: 8px;
}

.is-offline {
  color: #c5c8ce;
}

.empty-tip {
  text-align: center;
  color: #808695;
  padding: 30px 0;
}
</style>



// WEBPACK FOOTER //
// TchOnboardingManage.vue?6a462c95